// shared/common/playerPositions.js

export const PLAYER_POSITIONS = [
  { value: "Goalkeeper", labelKey: "positions.goalkeeper" },
  { value: "Defense", labelKey: "positions.defense" },
  { value: "Lateral", labelKey: "positions.lateral" },
  { value: "Midfield", labelKey: "positions.midfield" },
  { value: "Forward", labelKey: "positions.forward" },
];

export const PLAYER_POSITION_ORDER = PLAYER_POSITIONS.map((p) => p.value);

export const normalizePlayerPosition = (position) => {
  const value = String(position ?? "").trim();
  if (!value) return "Unknown";

  const compactKey = value.toLowerCase().replace(/[\s_-]+/g, "");
  if (["gardien", "gk", "goal", "goalkeeper"].includes(compactKey)) {
    return "Goalkeeper";
  }

  const canonical = PLAYER_POSITIONS.find(
    (entry) => entry.value.toLowerCase() === value.toLowerCase()
  );
  if (canonical) return canonical.value;

  return value;
};